module.exports = __webpack_public_path__ + "img/bannerN3.3e97fef6.png";